/**
 * 🍪 Biscuit Shop - Matrix Rain Effect
 * Subtle cybersecurity-themed background animation
 */

document.addEventListener('DOMContentLoaded', function() {
  // Create matrix rain effect
  function createMatrixRain() {
    const matrixContainer = document.createElement('div');
    matrixContainer.className = 'matrix-rain-container';
    matrixContainer.style.cssText = `
      position: fixed;
      top: 0;
      left: 0;
      width: 100%;
      height: 100%;
      pointer-events: none;
      z-index: -1;
      overflow: hidden;
    `;
    
    document.body.appendChild(matrixContainer);
    
    // Create floating binary digits with variety
    function createDigit() {
      const digit = document.createElement('div');
      const chars = ['1', '0', '1', '0', '1', '0', 'A', 'B', 'C', 'D', 'E', 'F', '1', '0', '1', '0', '1', '0', '0',];
      digit.textContent = chars[Math.floor(Math.random() * chars.length)];
      digit.style.cssText = `
        position: absolute;
                 color: rgba(110, 172, 218, ${Math.random() * 0.3 + 0.1});
         font-family: 'Courier New', monospace;
         font-size: ${Math.random() * 16 + 10}px;
        font-weight: bold;
        left: ${Math.random() * 100}%;
        top: -20px;
        animation: matrix-fall ${Math.random() * 15 + 10}s linear infinite;
      `;
      
      matrixContainer.appendChild(digit);
      
      // Remove digit after animation
      setTimeout(() => {
        if (digit.parentNode) {
          digit.parentNode.removeChild(digit);
        }
      }, 25000);
    }
    
    // Create CSS keyframes for falling animation
    const style = document.createElement('style');
    style.textContent = `
      @keyframes matrix-fall {
        0% {
          transform: translateY(-20px);
          opacity: 0;
        }
        10% {
          opacity: 1;
        }
        90% {
          opacity: 1;
        }
        100% {
          transform: translateY(100vh);
          opacity: 0;
        }
      }
    `;
    document.head.appendChild(style);
    
    // Create digits at a more subtle, atmospheric rate
    setInterval(createDigit, 1200);
    
    // Add secondary interval for gentle variation
    setInterval(createDigit, 1800);
    
    // Create modest initial burst
    for (let i = 0; i < 15; i++) {
      setTimeout(createDigit, i * 200);
    }
    
    // Create subtle digits on scroll
    let scrollTimeout;
    window.addEventListener('scroll', () => {
      clearTimeout(scrollTimeout);
      scrollTimeout = setTimeout(() => {
        for (let i = 0; i < 3; i++) {
          setTimeout(createDigit, i * 100);
        }
      }, 200);
    });
    
    // Add gentle background generation
    setInterval(() => {
      for (let i = 0; i < 2; i++) {
        setTimeout(createDigit, i * 300);
      }
    }, 4000);
  }
  
  // Initialize matrix effect
  createMatrixRain();
  
  // Add localized matrix effects to key sections
  function addSectionMatrix(selector) {
    const sections = document.querySelectorAll(selector);
    sections.forEach(section => {
      const localMatrix = document.createElement('div');
      localMatrix.style.cssText = `
        position: absolute;
        top: 0;
        left: 0;
        width: 100%;
        height: 100%;
        pointer-events: none;
        z-index: 1;
        overflow: hidden;
      `;
      
             // Create localized matrix digits
       function createLocalDigit() {
         const digit = document.createElement('div');
         const chars = ['1', '0', '1', '0', 'A', 'B', 'C', 'D', 'E', 'F', '1', '0'];
         digit.textContent = chars[Math.floor(Math.random() * chars.length)];
        digit.style.cssText = `
          position: absolute;
          color: rgba(110, 172, 218, 0.15);
          font-family: 'Courier New', monospace;
          font-size: 12px;
          left: ${Math.random() * 100}%;
          top: -20px;
          animation: matrix-fall ${Math.random() * 20 + 15}s linear infinite;
        `;
        
        localMatrix.appendChild(digit);
        
        setTimeout(() => {
          if (digit.parentNode) {
            digit.parentNode.removeChild(digit);
          }
        }, 35000);
      }
      
      section.style.position = 'relative';
      section.appendChild(localMatrix);
      
             // Create digits for this section much more frequently
       setInterval(createLocalDigit, 1000);
       
       // Add second interval for section density
       setInterval(createLocalDigit, 1500);
       
       // Initial burst for this section
       for (let i = 0; i < 8; i++) {
         setTimeout(createLocalDigit, i * 300);
       }
    });
  }
  
  // Add matrix to specific sections
  setTimeout(() => {
    addSectionMatrix('.shopify-section');
    addSectionMatrix('.footer');
    addSectionMatrix('.product-grid');
  }, 1000);
  
    // Add subtle hover effects to cards (excluding product listings)
  const cards = document.querySelectorAll('.card');
  cards.forEach(card => {
    card.addEventListener('mouseenter', function() {
      this.style.transform = 'translateY(-5px) scale(1.02)';
      this.style.boxShadow = '0 10px 30px rgba(110, 172, 218, 0.3)';
      
      // Skip matrix sparkles for product cards to avoid click interference
      const isProductCard = this.closest('.product-card-wrapper') || 
                           this.closest('.card-product') ||
                           this.closest('.grid__item') ||
                           this.querySelector('.card__heading') ||
                           this.querySelector('[href*="/products/"]');
      
      if (!isProductCard) {
        // Create burst of matrix digits on hover (non-product cards only)
        const burst = document.createElement('div');
        burst.style.cssText = `
          position: absolute;
          top: 0;
          left: 0;
          width: 100%;
          height: 100%;
          pointer-events: none;
          z-index: 5;
        `;
        
        for (let i = 0; i < 12; i++) {
          const digit = document.createElement('div');
          const chars = ['1', '0', '1', '0', 'A', 'B', 'C', 'D', 'E', 'F', '1', '0'];
          digit.textContent = chars[Math.floor(Math.random() * chars.length)];
          digit.style.cssText = `
            position: absolute;
            color: rgba(110, 172, 218, ${Math.random() * 0.4 + 0.3});
            font-family: 'Courier New', monospace;
            font-size: ${Math.random() * 8 + 8}px;
            left: ${Math.random() * 100}%;
            top: ${Math.random() * 100}%;
            animation: matrix-sparkle 0.8s ease-out forwards;
          `;
          burst.appendChild(digit);
        }
        
        this.style.position = 'relative';
        this.appendChild(burst);
        
        setTimeout(() => {
          if (burst.parentNode) {
            burst.parentNode.removeChild(burst);
          }
        }, 1000);
      }
    });
    
    card.addEventListener('mouseleave', function() {
      this.style.transform = '';
      this.style.boxShadow = '';
    });
  });
  
  // Add sparkle animation for card hover effect
  const sparkleStyle = document.createElement('style');
  sparkleStyle.textContent = `
    @keyframes matrix-sparkle {
      0% {
        opacity: 0;
        transform: scale(0.5);
      }
      50% {
        opacity: 1;
        transform: scale(1.2);
      }
      100% {
        opacity: 0;
        transform: scale(0.8) translateY(-20px);
      }
    }
  `;
  document.head.appendChild(sparkleStyle);
}); 